<script setup lang="ts">
import { LucideMenu } from 'lucide-vue-next'
import type { IMenuLinks } from './types'

// The menu content (ScrollArea, Accordion and the links) is loaded on first open,
// the header only needs the trigger button
const MobileSidebarContent = defineAsyncComponent(() => import('./MobileSidebarContent.vue'))

const props = defineProps<{ menuLinks: IMenuLinks }>()

// Stay mounted after the first open so the sheet can play its close animation
const isContentUsed = ref(false)

const handleOpenChange = (open: boolean) => {
  if (open) isContentUsed.value = true
}
</script>

<template>
  <Sheet @update:open="handleOpenChange">
    <SheetTrigger as-child>
      <Button
        variant="gray"
        size="icon"
        class="min-[1181px]:hidden"
        :aria-label="$t('widget.mobile_sidebar.menu_aria')"
      >
        <LucideMenu class="size-5" />
      </Button>
    </SheetTrigger>
    <MobileSidebarContent v-if="isContentUsed" :menu-links="props.menuLinks" />
  </Sheet>
</template>
